<script lang="ts" module>
  import type { TeoText } from '@/teoCore/text/TeoText';
  import type { UiWordListEntry } from '@/teoCore/text/WordListHandler/WordListHandler';
  import type { WordListSubHandler } from '@/teoCore/text/WordListHandler/WordListSubHandler';
  import Assistant, { type CardProps } from '@/ui/elements/assistant/Assistant.svelte';
  import type { AssistantVariant } from '@/ui/elements/assistant/AssistantCard/AssistantCard.svelte';
  import type { ImprovementProps } from '@/ui/elements/pills/Improvement.svelte';
  import { useTeoEventObserver } from '@/utils/use-teo-event-observer.svelte';
</script>

<script lang="ts">
  const {
    teoText,
    wordLists,
    title,
  }: { teoText: TeoText; wordLists: WordListSubHandler; title: string } = $props();
  let loading = useTeoEventObserver({
    initialValue: teoText.analysisPending,
    update: (eventName, pending) => pending,
    target: teoText.events,
    events: ['analysisPending'],
  });
  const cards = useTeoEventObserver({
    initialValue: uiWordListEntriesToCardProps(wordLists.currentEntries),
    update: () => uiWordListEntriesToCardProps(wordLists.currentEntries),
    target: wordLists.events,
    events: ['currentEntriesChanged'],
  });
  const focusedEntry = useTeoEventObserver({
    initialValue: wordLists.focusedEntry,
    update: () => wordLists.focusedEntry,
    target: wordLists.events,
    events: ['entryFocused'],
  });

  function uiWordListEntriesToCardProps(entries: UiWordListEntry[]): CardProps[] {
    return entries.map((entry) => ({
      ...entry,
      improvements: entry.suggestions as Omit<ImprovementProps, 'onclick'>[],
      variant: entry.variant as AssistantVariant,
    }));
  }

  function onDimensionChange(dimension: string | undefined) {
    console.log('onDimensionChange', dimension);
    if (!dimension) {
      wordLists.focusEntry(undefined);
      return;
    }
    const entry = wordLists.getEntryByRelation(dimension);
    wordLists.focusEntry(entry);
  }
</script>

<Assistant
  {title}
  loading={loading.current}
  onImprovementClick={(entryKey: string, suggestionKey: string) => {
    wordLists.useSuggestion(entryKey, suggestionKey);
  }}
  cards={cards.current}
  {onDimensionChange}
  dimension={focusedEntry.current?.key}
></Assistant>
